var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLiabilityShield = function SvgLiabilityShield(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0076FF",
    fillRule: "evenodd",
    d: "M15.513 1.137c2.296 1.705 4.84 2.774 7.623 3.197.571.087 1.146.154 1.721.2 1.704.139 2.369.889 2.342 2.677-.129 4.892-.996 9.592-3.3 13.907-2.113 3.96-5.14 6.953-8.86 9.196-.685.413-1.393.35-2.094-.004-5.924-2.988-9.754-7.789-11.348-14.532-.71-3.001-.862-6.055-.775-9.129.037-1.295.808-1.985 2.22-2.105 2.737-.233 5.364-.902 7.798-2.28.64-.363 1.261-.767 1.87-1.185.956-.655 1.863-.64 2.803.058zm3.93 9.343c-.608-.47-1.465-.334-1.914.303l-4.632 6.585c-.03.043-.077.07-.127.072-.048.002-.097-.018-.131-.057l-2.254-2.622c-.506-.589-1.371-.637-1.933-.106-.561.53-.606 1.439-.1 2.028l3.185 3.705c.356.413.87.637 1.4.61.53-.028 1.022-.303 1.337-.751l5.46-7.76c.448-.638.317-1.537-.29-2.007z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLiabilityShield, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/liability_shield.4bbd06da.svg";
export { ForwardRef as ReactComponent };